var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Layout',{attrs:{"containers":_vm.containers},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('HomeHeroBar',{attrs:{"section":'home4'},on:{"gradientButtonClicked":_vm.scrollToEstateCostCalculator}})]},proxy:true},{key:"info-tiles",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('InfoTilesContainer',{attrs:{"tiles":_vm.infoTiles,"buttonText":'CALCULATE MY COSTS',"alternativeTitle":`<span style='
              font-size: 28px;
              font-weight: 500;
              line-height: 34px;
              letter-spacing: -0.0025em;
              text-align: center;'>Protect your legacy. Estate costs affect everybody.</span> Plan ahead to protect their inheritance.
              <p style='
              margin:48px 0 35px 0;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              color:#747474;
              '>
              When you pass away, your loved ones could face unexpected estate costs and taxes such as:</p>`,"additionalText":`  <p style='
              margin:48px 0 35px 0;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              color:#747474;
              '>Without a plan, these costs can force the sale of assets — <span style='font-family: Montserrat;
              font-weight: 600;
              font-style: SemiBold;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              '>even your family home.</span></p>`},on:{"gradientButtonClicked":_vm.scrollToEstateCostCalculator}})],1)]},proxy:true},{key:"estate-cost-calculator",fn:function(){return [_c('div',{ref:"estateCostCalculatorSection",staticClass:"section-padding"},[_c('TitleRow',{attrs:{"html":true,"title":`<p style='
              font-weight: 300;
              font-size: 28px;
              line-height: 34px;
              letter-spacing: -0.25%;
              text-align: center;
              margin-bottom:0;
            '>
           Estate Administration Cost Calculator
            </p>`,"description":`<p style='
              font-weight: 400;
              font-size: 22px;
              line-height: 28px;
              text-align: center;
            '>
            Along with the heartache of death comes the additional burden of legal and administration fees. 
            It is important to <span style='
            font-weight: 600;
            '>
            plan for these costs</span> 
            so it does not cause stress for your loved ones at a time of grieving.
            </p>`}}),_vm._v(" "),_c('EstateCostCalculator',{attrs:{"customButton":true,"customButtonText":'CREATE MY WILL'}})],1)]},proxy:true},{key:"info-title-row",fn:function(){return [_c('TitleRow',{attrs:{"html":true,"title":`<p style='
                    font-weight: 400;
                    font-style: Regular;
                    font-size: 22px;
                    line-height: 28px;
                    letter-spacing: 0%;
                    text-align: center;
                    color: #1E1E1E;
                    '>
                    These are some of the costs your family may face.
                    <span style='
                    font-weight: 600;
                    font-style: SemiBold;
                    font-size: 22px;
                    line-height: 28px;
                    letter-spacing: 0%;
                    text-align: center;
                    '>
                    Without planning, they will be deducted from your estate
                    </span> 
                    before inheritance is paid your loved ones.</p>`,"description":''}})]},proxy:true},{key:"why-choose-us",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('ImageTextBanner',{attrs:{"imageUrl":_vm.whitelabel.images.home4ReduceCostsImage,"title":'How to reduce these costs and plan their future',"paragraphOne":`<p style='
                font-weight: 400;
                font-style: Regular;
                font-size: 16px;
                line-height: 28px;
                letter-spacing: 0%;
                color:#282828;
                '>
            Planning for these costs is done through an estate plan and documented in your will.</p>
            <p>By creating your will, you:</p>
            <ul class='list-disc'
            style='line-height: 28px;'
            >
              <li>Ensure your wishes are legally documented and followed</li>
              <li>Appoint an executor to wind up your estate</li>
              <li>Protect and provide for minor children</li>
              <li>Potentially reduce the amount to be paid on taxes and estate administration costs</li>
            </ul>
            <p style='
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 28px;
            letter-spacing: 0%;
            color:#282828;
            margin-top:24px;
            '>
            It takes less than 25 minutes to create your free, valid will online with Old Mutual.
            </p>
`,"reversed":true,"buttonText":'CREATE MY WILL',"bottomMargin":true},on:{"gradientButtonClicked":_vm.createYourWill}})],1)]},proxy:true},{key:"create-your-will-info",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('InfoTilesContainer',{attrs:{"tiles":_vm.infoTilesCreateYourWill,"buttonText":'CREATE MY FREE WILL',"alternativeTitle":`<p style='
              font-weight: 500;
              font-size: 28px;
              line-height: 32px;
              letter-spacing: -0.23px;
              text-align: center;
            '>
            How to create a will with Old Mutual
            </p>
            <p style='
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            color:#747474;
            margin-bottom:48px;
            '>
            With Old Mutual you can create your legally valid will online in as little as 25 minutes.
            </p>`,"additionalText":`
            <p style='
            font-weight: 400;
            font-style: Regular;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            color:#747474;
            '>
            When you create your will, <span
            style='font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            '>
          you also get access to EstateAssist</span> — personalised
            insurance cover that <span style='
            font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            '>shields your loved ones from costly estate 
            fees and taxes.</span>
            </p>
            `},on:{"gradientButtonClicked":_vm.createYourWill}})],1)]},proxy:true},{key:"create-your-will-banner",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('CreateYourWillBanner',{attrs:{"alternativeBanner":true,"bannerText":`<p style='
              font-weight: 600;
              font-size: 28px;
              line-height: 36px;
              text-align: center;
            '>Join 23,000+ South Africans 
            <span style='
              font-weight: 300;
              font-size: 28px;
              line-height: 36px;
              text-align: center;
            '>who’ve created their wills online with Old Mutual since 2023</span>
            </p>`,"pb0":true}})],1)]},proxy:true},{key:"take-control",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('ImageTextBanner',{attrs:{"imageUrl":_vm.whitelabel.images.home1JoinUsImage,"title":`<p style='
                font-weight: 600;
                font-size: 28px;
                line-height: 36px;
                color:#282828;
                '>
                You’ve seen the costs. Now take control and plan for it.
                </p>`,"paragraphOne":`
            <p style='
            font-weight: 300;
            font-size: 28px;
            line-height: 36px;
              color:#282828;
            '>
            Don’t let estate costs and taxes take away your family’s inheritance. Protect your family and your wishes today.
            </p>`,"reversed":true,"buttonText":'CREATE MY WILL',"bottomMargin":true},on:{"gradientButtonClicked":_vm.createYourWill}})],1)]},proxy:true},{key:"callusback",fn:function(){return [(_vm.whitelabel.brand !== 'quickwill')?_c('EstateAdministrationCostCalculatorFooter',{on:{"requestACall":_vm.requestACall}}):_vm._e()]},proxy:true}])}),_vm._v(" "),_c('SuccessSnackbar',{attrs:{"message":_vm.alertMessage},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}}),_vm._v(" "),_c('RequestACallDialog',{attrs:{"showRequestACallDialog":_vm.showRequestACallDialog},on:{"update:showRequestACallDialog":function($event){_vm.showRequestACallDialog=$event},"update:show-request-a-call-dialog":function($event){_vm.showRequestACallDialog=$event},"success":_vm.showSuccessMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }